const Pitchdeck = () => {
  return (
    <iframe
      src="/about/PhiCorp Pitchdeck.pdf"
      title="Phi Corp Pitchdeck"
      style={{
        width: "100%",
        height: "100vh",
        border: "none",
      }}
    />
  );
};



export default Pitchdeck;